<template>
  <div>
    <div class="bg-tax-1">
      <div class="h-45px m-auto flex justify-between items-center px-10px xl:w-1170px xl:px-0">
        <a target="_blank" href="//yorkbbs.ca" class="text-22px font-bold text-tax-2 hover:underline">YorkBBS.CA</a>
        <div class="flex items-center">
          <a class="text-base text-tax-2 hover:underline mr-22px" target="_blank" href="//yorkbbs.ca">网站首页</a>
          <a class="text-base text-tax-2 hover:underline mr-22px" target="_blank" href="//news.yorkbbs.ca">新闻</a>
          <a class="text-base text-tax-2 hover:underline" target="_blank" href="//forum.yorkbbs.ca">论坛</a>
        </div>
      </div>
    </div>

    <YorkbbsImage
      :src="require('./assets/banner-big.jpg')"
      class="mb-4 hidden md:block"
      :animation="false"
    ></YorkbbsImage>

    <YorkbbsImage
      :src="require('./assets/banner-small.jpg')"
      class="mb-22px block md:hidden"
      :animation="false"
    ></YorkbbsImage>

    <div class="w-1170px mx-auto hidden lg:block">
      <!-- 分享 -->
      <YorkbbsShare></YorkbbsShare>
    </div>

    <div class="mx-auto px-10px xl:w-1170px xl:px-0 mb-30px md:mb-40px">
      <div class="text-center text-tax-3 font-bold text-24px mb-22px md:text-40px md:mb-44px">金牌推荐</div>
      <div class="grid grid-rows-4 grid-cols-2 gap-10px md:grid-rows-2 md:grid-cols-4 mb-30px" v-if="adv.jinpai_1">
        <YorkbbsImage
          v-for="i in 8"
          :key="i"
          :src="adv[`jinpai_${i}`]['imgSrc']"
          :href="adv[`jinpai_${i}`]['url']"
          target="_blank"
          animation
        >
        </YorkbbsImage>
      </div>

      <div class="flex justify-center px-30px">
        <a
          class="box-border h-42px px-20px flex justify-center items-center rounded-full border bg-f8 text-base text-666 hover:bg-tax-4 hover:text-tax-5 hover:border-transparent"
          target="_blank"
          href="https://info.yorkbbs.ca/list/tax"
        >
          一键咨询更多报税问题 >
        </a>
      </div>
    </div>

    <div class="mx-auto px-10px xl:w-1170px xl:px-0 mb-22px md:mb-40px" v-if="adv['zhinan_1']">
      <div class="text-center text-tax-3 font-bold text-24px mb-22px md:text-40px md:mb-44px">报税指南</div>

      <div
        class="grid grid-cols-2 grid-rows-2 gap-x-2 gap-y-5 mb-22px md:mb-44px md:grid-cols-4 md:grid-rows-1 md:gap-x-6"
      >
        <a target="_blank" class="hover:text-tax-6" v-for="i in 4" :key="i" :href="adv[`zhinan_${i}`]['url']">
          <YorkbbsImage aspect class="mb-10px" :src="adv[`zhinan_${i}`]['imgSrc']" animation>
            <div
              class="absolute left-0 right-0 bottom-0 z-10 h-35px flex items-center px-10px bg-tax-8 text-white text-base truncate"
            >
              {{ adv[`zhinan_${i}`]['textFiled2'] }}
            </div>
          </YorkbbsImage>
          <div class="text-base line-clamp-2">{{ adv[`zhinan_${i}`]['textFiled1'] }}</div>
        </a>
      </div>
      <YorkbbsImage
        v-if="adv['tonglan_1']"
        :src="adv['tonglan_1']['imgSrc']"
        target="_blank"
        :href="adv['tonglan_1']['url']"
      ></YorkbbsImage>
    </div>

    <!-- 报税攻略 -->
    <div class="mx-auto mb-40px px-10px xl:w-1170px xl:px-0">
      <div class="text-center text-tax-3 font-bold text-24px mb-22px md:text-40px md:mb-44px">报税攻略</div>

      <!-- 标签 -->
      <div class="flex flex-wrap mb-26px">
        <a
          class="px-1 md:px-4 h-8 md:h-10 flex justify-center items-center bg-f8 border border-eee rounded-sm mr-3 mb-3 hover:bg-tax-4 hover:text-tax-5 hover:border-transparent"
          v-for="(tag, i) in tags"
          :key="i"
          target="_blank"
          :href="tag.link"
        >
          {{ tag.title }}
        </a>
      </div>

      <!-- 列表 -->
      <div class="grid grid-cols-2 grid-rows-2 gap-x-3 gap-y-4 md:gap-y-12 mb-14">
        <div class="box-border md:pr-4" v-for="(group, i) in strategies" :key="i">
          <div class="text-tax-3 font-bold pl-6px border-l-4 border-tax-3 text-xl leading-none mb-20px hidden md:block">
            {{ group.label }}
          </div>
          <div class="flex">
            <YorkbbsImage
              aspect
              animation
              class="w-220px rounded-tl-sm rounded-bl-sm"
              :src="group.items[0]['image']"
              :href="group.items[0]['link']"
              target="_blank"
            >
              <div
                class="absolute left-0 right-0 bottom-0 px-2 z-10 h-40px bg-black-5 text-base text-white flex items-center hover:text-tax-6"
              >
                {{ group.items[0]['title'] }}
              </div>
            </YorkbbsImage>
            <div class="flex-1 w-0 pl-25px flex-col justify-between hidden md:flex">
              <a
                target="_blank"
                v-for="(item, j) in group.items.slice(1, 6)"
                :key="j"
                :href="item.link"
                class="block text-base hover:text-tax-6 truncate"
                >{{ item.title }}</a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- 广告 -->
      <YorkbbsImage
        v-if="adv['tonglan_2']"
        :src="adv['tonglan_2']['imgSrc']"
        target="_blank"
        :href="adv['tonglan_2']['url']"
      ></YorkbbsImage>
    </div>

    <!-- 报税建议 -->
    <div class="mx-auto flex items-start px-10px xl:w-1170px xl:px-0">
      <div class="flex-1 w-0 md:pr-14">
        <div class="text-center lg:text-left text-tax-3 font-bold text-24px mb-22px md:text-40px md:mb-44px">
          报税建议
        </div>

        <YorkbbsProjectItem v-for="(subject, i) in subject.items" :data="subject" :key="i"></YorkbbsProjectItem>

        <el-pagination
          class="text-center mt-42px hidden lg:block"
          :current-page.sync="subject.offset"
          :page-size="subject.size"
          :total="subject.itemTotal"
          hide-on-single-page
          background
          prev-text="上一页"
          next-text="下一页"
          layout="prev, pager, next"
          @current-change="onPageChange"
        ></el-pagination>

        <div class="text-center lg:hidden">
          <button
            class="h-9 w-32 bg-eee rounded-sm mr-20px disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="subject.offset === 1"
            @click="onPageChange(subject.offset - 1)"
          >
            上一页
          </button>
          <button
            class="h-9 w-32 bg-eee rounded-sm disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="subject.offset === subject.pageTotal"
            @click="onPageChange(subject.offset + 1)"
          >
            下一页
          </button>
        </div>
      </div>

      <YorkbbsImage
        class="hidden md:block"
        v-if="adv['right_1']"
        :src="adv['right_1']['imgSrc']"
        target="_blank"
        :href="adv['right_1']['url']"
      ></YorkbbsImage>
    </div>

    <YorkbbsImage
      class="md:hidden mx-4 mt-12"
      v-if="adv['right_1']"
      :src="adv['right_1']['imgSrc']"
      target="_blank"
      :href="adv['right_1']['url']"
    ></YorkbbsImage>

    <YorkbbsFooter></YorkbbsFooter>
    <YorkbbsBackTop></YorkbbsBackTop>
  </div>
</template>
<script>
import '@/assets/css/tax.css';
import { bannerAdvConvert } from '@/utils/utils';
import YorkbbsProjectItem from './item-subject.vue';
import YorkbbsFooter from '@/components/footer';
import YorkbbsBackTop from '@/components/back-top.vue';
import YorkbbsShare from '@/components/share.vue';
export default {
  name: 'Tax2022',
  components: { YorkbbsProjectItem, YorkbbsFooter, YorkbbsBackTop, YorkbbsShare },
  data() {
    return {
      // 报税攻略标签
      tags: [
        {
          title: '报税问题指南一步到位',
          link: 'https://news.yorkbbs.ca/detail/money/2734d362-a1b2-475f-9439-149271b967b4',
        },
        {
          title: '报税小技巧',
          link: 'https://news.yorkbbs.ca/detail/money/30169581-4a0e-4878-9014-ce7f8ce3ee7e',
        },
        {
          title: '报税新变化',
          link: 'https://news.yorkbbs.ca/detail/local/cb0c9525-2ccf-437e-bb42-046881774d45',
        },
        {
          title: '报税注意事项',
          link: 'https://news.yorkbbs.ca/detail/money/810be469-d098-4c50-9a48-120a7722762f',
        },
        {
          title: '留学生报税指南',
          link: 'https://news.yorkbbs.ca/detail/money/b9ccb4c1-874b-47e9-810d-882ff1879e70',
        },
        {
          title: '小生意报税',
          link: 'https://news.yorkbbs.ca/detail/money/6ef2375c-e6ec-422c-bb82-bd2d14372b5f',
        },
        {
          title: '新移民报税',
          link: 'https://news.yorkbbs.ca/detail/money/2734d362-a1b2-475f-9439-149271b967b4',
        },
        {
          title: '自雇人士报税',
          link: 'https://news.yorkbbs.ca/detail/money/6ef2375c-e6ec-422c-bb82-bd2d14372b5f',
        },
      ],
      // 报税攻略
      strategies: [
        {
          label: '新移民报税',
          items: [
            {
              title: '报税基本知识',
              link: 'https://news.yorkbbs.ca/detail/money/c85d3554-3da6-4801-bf63-f9283ca0e273',
              image: require('./assets/tax01.png'),
            },
            {
              title: '关键内容！新移民报税特别注意事项！',
              link: 'https://news.yorkbbs.ca/detail/money/810be469-d098-4c50-9a48-120a7722762f',
            },
            {
              title: '新移民报税问题合集：哪些收入必须申报？',
              link: 'https://news.yorkbbs.ca/detail/money/2734d362-a1b2-475f-9439-149271b967b4',
            },
            {
              title: '加拿大2022年报税季 这些变化你需要知道',
              link: 'https://news.yorkbbs.ca/detail/local/cb0c9525-2ccf-437e-bb42-046881774d45',
            },
            {
              title: '加拿大报税季，这些细节和误区你要注意',
              link: 'https://news.yorkbbs.ca/detail/money/3ffbd61d-af85-4234-ba6c-8985997303bf',
            },
            {
              title: '华人注意！领了CRB报税需偿还，每1刀还0.5！',
              link: 'https://news.yorkbbs.ca/detail/local/e2ea5081-1bfc-45e0-a653-deffe72d4ce1',
            },
          ],
        },
        {
          label: '留学生报税',
          items: [
            {
              title: '留学生报税条件',
              link: 'https://news.yorkbbs.ca/detail/local/3047803e-f828-438c-81e0-d777f507c9c8',
              image: require('./assets/tax02.png'),
            },
            {
              title: '2022年加拿大留学生报税材料参考',
              link: 'https://news.yorkbbs.ca/detail/money/7983abc9-04c9-4f75-aaaf-bfe9d354ff7b',
            },
            {
              title: '加拿大留学生退税途径及报税注意事项一览',
              link: 'https://news.yorkbbs.ca/detail/money/80405c85-5302-4c3d-8e09-3d17d6dc9302',
            },
            {
              title: '留学生必看！学费及教育费的免税规定！',
              link: 'https://news.yorkbbs.ca/detail/money/775e1ffc-3d1b-49f6-ab9e-7c80cabd1e0b',
            },
            {
              title: '留学生必备：加拿大留学生报税退税步骤详解',
              link: 'https://news.yorkbbs.ca/detail/money/b9ccb4c1-874b-47e9-810d-882ff1879e70',
            },
            {
              title: '留学生报税流程，注意事项都给你列出来了！',
              link: 'https://news.yorkbbs.ca/detail/money/775e1ffc-3d1b-49f6-ab9e-7c80cabd1e0b',
            },
          ],
        },
        {
          label: '公司报税',
          items: [
            {
              title: '公司报税最全解析',
              link: 'https://news.yorkbbs.ca/detail/money/32be87bc-7f99-4e39-91eb-15db2f6d9756',
              image: require('./assets/tax03.png'),
            },
            {
              title: '快收藏！加拿大公司报税常见问题攻略',
              link: 'https://news.yorkbbs.ca/detail/money/a5ae46ce-e8dc-4944-89e9-3f23a53d7e1d',
            },
            {
              title: '还在迷茫吗？2022年加拿大公司报税指南',
              link: 'https://news.yorkbbs.ca/detail/money/b7306a42-b89f-4866-992b-b4036740eae4',
            },
            {
              title: '加拿大不同形式公司报税的一些注意事项',
              link: 'https://news.yorkbbs.ca/detail/money/a61de6a3-1bc9-4845-80c5-49683cc7090c',
            },
            {
              title: '注意！收到CRA审查信，不回可能福利全没！',
              link: 'https://news.yorkbbs.ca/detail/local/fcb46d7d-463c-497c-b9e1-4cf61a608753',
            },
            {
              title: '可省钱！加拿大公司报税优惠项目参考',
              link: 'https://news.yorkbbs.ca/detail/money/b7306a42-b89f-4866-992b-b4036740eae4',
            },
          ],
        },
        {
          label: '自雇/小生意报税',
          items: [
            {
              title: '自雇和小生意报税技巧',
              link: 'https://news.yorkbbs.ca/detail/money/6ef2375c-e6ec-422c-bb82-bd2d14372b5f',
              image: require('./assets/tax04.png'),
            },
            {
              title: '2022年自雇及小生意税所需资料都在这',
              link: 'https://news.yorkbbs.ca/detail/money/7d7e432f-fb12-4316-854e-ea88d6b2dc20',
            },
            {
              title: '2022年自雇和小生意报税可抵扣的费用一览',
              link: 'https://news.yorkbbs.ca/detail/money/5f229e4f-9935-4485-9bc3-8cd276c78f3f',
            },
            {
              title: '谨慎！加拿大业主易被查税的十大情况',
              link: 'https://news.yorkbbs.ca/detail/local/7aa32bb6-4de2-4b81-884b-d6debb3d02f2',
            },
            {
              title: '免费报税工具完整优缺点对照，总有一款适合你！',
              link: 'https://news.yorkbbs.ca/detail/local/5f62a70e-46b5-44f9-b124-e6d0e0d3bdab',
            },
            {
              title: '气到吐血！报税季有人因这个疏忽被CRA重罚22万',
              link: 'https://news.yorkbbs.ca/detail/money/87191f2c-2a2c-49cf-8e6a-e49cdab02a0f',
            },
          ],
        },
      ],

      adv: {},

      subject: {
        offset: 1,
        size: 10,
        itemTotal: 0,
        pageTotal: 0,
        items: [],
      },
    };
  },
  created() {
    this.getAdvList();

    this.getSubjectList();
  },
  methods: {
    /**
     * 获取广告
     */
    async getAdvList() {
      const zoomId = 10653;

      const { data } = await this.$axios.post('/crm/section/v1/get/list/open', { id: zoomId });

      this.adv = bannerAdvConvert(data, '2022-tax', zoomId);
    },
    /**
     * 获取专题列表
     */
    async getSubjectList() {
      const { data } = await this.$axios.post('/cms/v1/get/subject/list/data', {
        offset: this.subject.offset,
        size: this.subject.size,
        keyword: '报税',
      });
      this.subject.items = data.items;
      this.subject.itemTotal = data.itemTotal;
      this.subject.pageTotal = data.pageTotal;
    },
    /**
     * 翻页
     */
    onPageChange(page) {
      this.subject.offset = page;
      this.getSubjectList();
    },
  },
};
</script>
<style>

</style>
<style lang="less" scoped>
img{border:0}

::v-deep {
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .btn-next {
    padding: 0 10px;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover,
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #e6c79e;
    color: #000;
  }
}
</style>
